export const columnRkToTableRk = (rk: string) => {
  const splits = rk.split("/");
  splits.pop();
  return splits.join("/");
};
export const destructTable = (table: string) => {
  const [datastore_type, splits] = table.split("://");
  if (datastore_type === "dbt") {
    const [_, uniqueId] = splits.split("/");
    const _splits = uniqueId.split(".");
    const n = _splits.length;
    return [datastore_type, _splits.slice(0, n - 1).join("."), _splits[n - 1]];
  }
  // TODO: fix this
  if (!splits) {
    return ["dbt", datastore_type, datastore_type];
  }
  const [schema, tableName] = splits.split("/");
  return [datastore_type, schema, tableName];
};

export const destructColumn = (c: string): [string, string] => {
  const splits = c.split("/");
  const column = splits.pop() || "";
  const table = splits.join("/");
  return [table, column];
};
